import React from 'react';
import { Space } from 'antd';
import Container from '../../components/UI/Container/Container';
import MainScreen from '../../components/UI/MainScreen/MainScreen';
import FeaturesBar from '../../components/UI/FeaturesBar/FeaturesBar';
import ProductList from '../../components/ProductList/ProductList';
import HowItWorks from '../../components/HowItWorks/HowItWorks';
import PaymentMethodsSection from '../../components/PaymentMethodsSection/PaymentMethodsSection';
import MobileAppBanner from '../../components/MobileAppBanner/MobileAppBanner';

const MainPage = () => {
  return (
    <div style={{ width: '100vw' }}>
      <MainScreen />
      <FeaturesBar />
      <Container style={{ margin: '60px auto 150px' }}>
        <Space direction='vertical'>
          <ProductList />
        </Space>
        <MobileAppBanner />
        <HowItWorks />
        <PaymentMethodsSection />
      </Container>
    </div>
  );
};

export default MainPage;
